import dayjs from 'dayjs'
import cpf from 'dayjs/plugin/customParseFormat'
dayjs.extend(cpf)

const VALID_USERNAME = 'abcdefghijklmnopqrstuvwxyz-'

const dateRegex = /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/

function getAge(dateString: string): number {
  const today = new Date()
  const birthDate = new Date(dateString)
  let age = today.getFullYear() - birthDate.getFullYear()
  const m = today.getMonth() - birthDate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}

export const rulesWithFalse = {
  dateString: (v: string): boolean | string =>
    (v && dateRegex.test(v) && dayjs(v, 'YYYY-MM-DD', true).isValid()) || false,
}

export const rules = {
  studentName(v: string): string | boolean {
    if (!v) return 'This field is required.'

    for (const char of v.toLocaleLowerCase()) {
      if (!VALID_USERNAME.includes(char))
        return `Invalid character "${char}" in student name. Must be alphabetical only, with no special characters or spaces.`
    }
    return true
  },
  required: (v: string | boolean | number): boolean | string =>
    !!v || 'This field is required.',
  requiredNumber: (v: number): boolean | string =>
    v !== null || 'This field is required.',
  dateString: (v: string): boolean | string =>
    (v && dateRegex.test(v) && dayjs(v, 'YYYY-MM-DD', true).isValid()) ||
    'Must be in valid YYYY-MM-DD format.',
  requiredPhoneNumber: (v: string): boolean | string =>
    /^(?:\+?\d{1,2}\s?)?(\(?\d{2,3}\)?\s?)?\(?\d{2,4}\)?[-.\s]?\d{2,4}[-.\s]?\d{4}$/.test(
      v
    ) || 'Please enter a valid phone number.',
  maxAge(this: number, v: string): boolean | string {
    if (!this) return true
    if (getAge(v) >= this) return `Student must not be older than ${this}`
    return true
  },
  minAge(this: number, v: string): boolean | string {
    if (!this) return true
    if (getAge(v) < this) return `Student must be at least ${this} years old`
    return true
  },
  oneCampType(this: Record<string, string | null>) {
    if (!this) return true
    const camps = Object.values(this).filter((el) => el)
    const set = new Set(camps)
    // console.log('camps is', camps)
    // console.log('set is', set)
    if (camps.length !== set.size)
      return 'Student can only enroll in one of each camp'
    return true
  },
  isNotNull: (v: boolean) => v !== null || 'Please select an option above.',
}

export default rules
